import { Box } from "@mui/material"
import type { ReactElement } from "react"

import type { BaseUploadBoxProps } from "../types"

export const DefaultUploadBox = ({
  children,
  className,
  isOver,
  canDrop,
  isHovered,
}: BaseUploadBoxProps): ReactElement => (
  <Box
    className={`relative flex cursor-pointer items-center justify-center rounded border border-dashed border-gray-400 bg-white transition-all duration-200 hover:border-primary ${
      isOver && canDrop ? "border-primary" : ""
    } ${isHovered ? "border-primary" : ""} ${className || ""}`}
  >
    {children}
  </Box>
)
